// extracted by mini-css-extract-plugin
module.exports = {"root":"CornerBorders_root__nMvGa","isActive":"CornerBorders_isActive__FIBE_"};